import { TranslationKeys } from '~/common/types';
import { OfferDebugData } from '~/purchase/types';

export const DEBUG_PRICING_SOURCE_LOOKUP_LABEL: Record<
  OfferDebugData['pricingSource'],
  keyof TranslationKeys
> = {
  standard_pricing_policy: 'app.purchase.debug.pricing.standard_pricing_policy',
  redistribution_pricing_policy:
    'app.purchase.debug.pricing.redistribution_pricing_policy',
  quote_pricing_policy: 'app.purchase.debug.pricing.quote_pricing_policy',
  customer_promo_pricing_policy:
    'app.purchase.debug.pricing.customer_promo_pricing_policy',
  wyz_promo_pricing_policy:
    'app.purchase.debug.pricing.wyz_promo_pricing_policy',
  get_stock_price: 'app.purchase.debug.pricing.get_stock_price',
  manufacturer_price: 'app.purchase.debug.pricing.manufacturer_price',
  stock_report_price: 'app.purchase.debug.pricing.stock_report_price',
  undefined: 'app.purchase.debug.pricing.undefined',
};
